// extracted by mini-css-extract-plugin
export default {"anchor":"kO1jxYKj_n"};